// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-tip[data-v-661e3b32] {\n  font-size: 12px;\n  color: #909399;\n  line-height: 1.5;\n  margin-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
